import Header from "./components/header";
import Footer from "./components/footer";
import {
  ComingSoonSection,
  CTASection,
  FeaturesSection,
  FounderSection,
  HeroSection,
  HowItWorksSection,
  LogoSection,
  ProblemStatement,
} from "./components/sections";

export default function App() {
  const comingSoon = true;
  return (
    <div className="size-full bg-white overflow-y-auto">
      {/* Header */}
      <Header comingSoon={comingSoon} />
      {/* Hero Section */}

      {comingSoon && <ComingSoonSection />}
      {!comingSoon && (
        <>
          <HeroSection />

          {/* Problem Statement */}
          <ProblemStatement />

          {/* Features Section */}
          <FeaturesSection />

          {/* How It Works */}
          <HowItWorksSection />

          {/* Logo Showcase */}
          <LogoSection />

          {/* Founder Section */}
          <FounderSection />

          {/* CTA Section */}
          <CTASection />
        </>
      )}

      {/* Footer */}
      <Footer comingSoon={comingSoon} />
    </div>
  );
}
